import { Block, ParagraphMedium, useStyletron } from "@mezo-org/mezo-clay"

import { RootState, selectTokenDecimals, useDappSelector } from "#/redux-state"
import SuccessfulActionModalBody from "#/shared/components/modals/SuccessfulActionModalBody"
import { VaultDepositFormValue } from "#/shared/types"
import { bigIntToHumanReadableFormat, getCurrencySymbol } from "#/shared/utils"
import {
  ComponentStepProps,
  useStepperModalContext,
} from "#/ui/Modal/StepperModal"

export default function SuccessfullyDepositedIntoVault({
  onClickContinue,
}: ComponentStepProps) {
  const [css, theme] = useStyletron()

  const {
    values: { token, amount },
  } = useStepperModalContext<VaultDepositFormValue>()

  const tokenDecimals = useDappSelector((state: RootState) =>
    selectTokenDecimals(state, token),
  )

  return (
    <SuccessfulActionModalBody
      title="Success"
      description={
        <ParagraphMedium
          className={css({
            textAlign: "center",
            padding: `${theme.sizing.scale500} ${theme.sizing.scale600}`,
          })}
        >
          You’ve deposited{" "}
          <Block as="span" style={{ fontWeight: "700" }}>
            {bigIntToHumanReadableFormat(
              amount ?? 0n,
              tokenDecimals,
              token === "MUSD" ? 2 : 4,
            )}{" "}
            {getCurrencySymbol(token)}
          </Block>{" "}
          into the August {getCurrencySymbol(token)} Vault.
        </ParagraphMedium>
      }
      onClickContinue={onClickContinue}
      nextStepButtonLabel="Done"
    />
  )
}
